import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/bootstrap.css";
import "./assets/css/main.css";
import "./assets/css/icomoon.css";
import "./assets/css/noto-nastaliq-urdu.css";
import "./assets/css/style.css";

import { App } from "components/app";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/browser";

import * as dotenv from "dotenv";

dotenv.config();

if (process.env.REACT_APP_SENTRY_ENABLED != 0) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_FRONTEND_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT_NAME
  });
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
